var map = {
	"./404.svg": "49be",
	"./bofang.svg": "b9a7",
	"./fanhuidingbu.svg": "e02c",
	"./gou.svg": "4232",
	"./guanbi.svg": "9440",
	"./jiantou.svg": "c9ce",
	"./pause.svg": "b8492",
	"./toggle.svg": "ed26",
	"./xiala1.svg": "6f87",
	"./yuyan.svg": "e61d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";